import { render } from "./StrengthPage.vue?vue&type=template&id=c41b2f5e"
import script from "./StrengthPage.vue?vue&type=script&lang=js"
export * from "./StrengthPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__